import {
  Component,
  OnInit,
  Input,
  ViewChild,
  OnDestroy,
  Output,
  EventEmitter,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { DataService } from "../../../../@core/utils/data.service";
import { DialogAttributeComponent } from "../dialog-attribute/dialog-attribute.component";
import { SettingCallFlowsComponent } from "../setting-callflows/setting-callflows.component";
import { AlertDialogComponent } from "../../../../shared/alert-dialog/alert-dialog.component";

@Component({
  selector: "app-ivr-attribute",
  templateUrl: "./ivr-attribute.component.html",
  styleUrls: ["./ivr-attribute.component.scss"],
})
export class IvrAttributeComponent implements OnInit, OnDestroy {
  @Input() isReadOnly: any = false;
  @Input() isAllowDesign: any = false;
  selectedItem: any;
  variableList: any;
  searchText: string = "";
  variableCategories: any[] = [
    { value: "System", default: "1" },
    { value: "Environment", default: "2" },
    { value: "User", default: "0" },
  ];
  @ViewChild("systemAccordion") systemAccordion;
  @ViewChild("envAccordion") envAccordion;
  @ViewChild("userAccordion") userAccordion;
  tabsOpened: string[] = [];
  @Output() accordionsOpened = new EventEmitter<any>();
  @Input() accordions: string[];
  expandedSections = {
    system: false,
    env: false,
    user: false,
  };
  constructor(
    public dataService: DataService,
    public dialogService: NbDialogService
  ) {}
  routerVariable() {
    window.open("https://docs.primas.net/display/CAL/Variable");
  }
  ngOnInit() {
    this.dataService.ivrAttribute = [
      { default: 1, value: "SESSION" },
      { default: 1, value: "UNIQUE_ID" },
      { default: 1, value: "CALLER_NUMBER" },
      { default: 1, value: "DIAL_NUMBER" },
      { default: 1, value: "SENDER" },
      { default: 1, value: "RECEIVER" },
      { default: 1, value: "CHANNEL_BOT" }, //IVR OR CHAT
      { default: 1, value: "LANGUAGE" },
      { default: 1, value: "SIP_HEADERS" },
      { default: 1, value: "DURATION" },
      { default: 1, value: "ERROR_CODE" },
      { default: 1, value: "ERROR_MESSAGE" },
      { default: 1, value: "CURRENT_ACTION_NAME" },
      { default: 1, value: "MAX_NO_INPUT" },
      { default: 1, value: "MAX_NOT_MATCH" },
      { default: 1, value: "CONVERSATION" },
      { default: 1, value: "CALL_FLOW_ID" },
      { default: 1, value: "DIAL_STATUS" },
      { default: 1, value: "TRANSFER_STATUS" },
      { default: 1, value: "QUEUE_STATUS" },
      { default: 1, value: "FIRST_NAME" },
      { default: 1, value: "LAST_NAME" },
      { default: 1, value: "NAME" },
      { default: 1, value: "PROFILE_PIC" },
      { default: 1, value: "USER_INPUT" },
      { default: 1, value: "BOT_RESPONSE" },
      { default: 1, value: "CALL_RECORDING_PATH" },
      { default: 1, value: "SIP_SERVER" },

      ...(!this.dataService.ivrAttribute ? [] : this.dataService.ivrAttribute),
    ];
    this.dataService.ivrAttribute = this.removeDuplicateValues(
      this.dataService.ivrAttribute
    );

    this.dataService.ivrAttributeArray = [
      "SESSION",
      "UNIQUE_ID",
      "CALLER_NUMBER",
      "DIAL_NUMBER",
      "SENDER",
      "RECEIVER",
      "CHANNEL_BOT",
      "LANGUAGE",
      "SIP_HEADERS",
      "DURATION",
      "ERROR_CODE",
      "ERROR_MESSAGE",
      "CURRENT_ACTION_NAME",
      "MAX_NO_INPUT",
      "MAX_NOT_MATCH",
      "CONVERSATION",
      "CALL_FLOW_ID",
      "DIAL_STATUS",
      "TRANSFER_STATUS",
      "QUEUE_STATUS",
      "FIRST_NAME",
      "LAST_NAME",
      "NAME",
      "PROFILE_PIC",
      "USER_INPUT",
      "BOT_RESPONSE",
      "CALL_RECORDING_PATH",
      "SIP_SERVER",
    ];

    this.variableList = this.dataService.ivrAttribute;
  }

  ngAfterViewInit(): void {
    this.openAccordions();
    this.tabsOpened.forEach((openTab) => {
      if (this.expandedSections.hasOwnProperty(openTab)) {
        this.expandedSections[openTab] = true;
      }
    });
  }

  ngOnDestroy(): void {
    this.accordionsOpened.emit(this.tabsOpened);
  }

  openAccordions() {
    if (this.accordions != null) {
      this.accordions.forEach((acc) => {
        if (acc === "env") {
          this.envAccordion.open();
        }
        if (acc === "user") {
          this.userAccordion.open();
        }
        if (acc === "system") {
          this.systemAccordion.open();
        }
      });
    }
    this.tabsOpened = this.accordions;
  }

  removeDuplicateValues(ivrAttribute) {
    const uniqueValues = [];

    for (const item of ivrAttribute) {
      if (!uniqueValues.some((u) => u.value === item.value)) {
        if (item.default == 1 && item.value == "UNIQUEID") {
        } else {
          uniqueValues.push(item);
        }
      }
    }

    return uniqueValues;
  }

  dragStart($event) {
    $event.dataTransfer.setData("text", $event.toElement.textContent);
  }

  filterVariable() {
    if (!this.searchText?.trim()) {
      this.variableList = [...this.dataService.ivrAttribute];
      this.closeAllAccordions();
      return;
    }

    const searchTerm = this.searchText.toLowerCase().trim();

    this.variableList = this.dataService.ivrAttribute.filter((attribute) => {
      const variableName = attribute.value?.toString().toLowerCase() || "";
      return variableName.includes(searchTerm);
    });

    if (this.variableList.length > 0) {
      this.toggleAccordions();
    } else {
      this.closeAllAccordions();
    }
  }

  toggleAccordions() {
    const sectionsToOpen = {
      user: this.variableList.some((variable) => variable.default === 0),
      system: this.variableList.some((variable) => variable.default === 1),
      env: this.variableList.some((variable) => variable.default === 2),
    };

    if (sectionsToOpen.env) this.envAccordion.open();
    if (sectionsToOpen.user) this.userAccordion.open();
    if (sectionsToOpen.system) this.systemAccordion.open();
  }

  closeAllAccordions() {
    this.envAccordion.close();
    this.userAccordion.close();
    this.systemAccordion.close();
  }

  addAttribute() {
    this.selectedItem = null;
    this.dialogService
      .open(DialogAttributeComponent, {
        autoFocus: false,
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((rs) => {
        if (rs) {
          this.filterVariable();
        }
      });
  }

  editAttribute(selectedItem) {
    this.selectedItem = selectedItem;
    if (selectedItem.default == 0) {
      let index = this.dataService.ivrAttribute.indexOf(selectedItem);

      this.dialogService
        .open(DialogAttributeComponent, {
          autoFocus: false,
          closeOnBackdropClick: false,
          context: {
            index: index,
            value: selectedItem?.value,
            content: selectedItem?.content || "",
            currentValue: selectedItem?.value || "",
          },
        })
        .onClose.subscribe((rs) => {
          this.filterVariable();
        });
    } else if (this.selectedItem.default == 2) {
      this.dialogService
        .open(SettingCallFlowsComponent, {
          closeOnBackdropClick: false,
          autoFocus: false,
          context: {
            updateVariable: true,
            updateVariableName: selectedItem?.value,
            updateCurrentVariableName: selectedItem?.value,
            updateVariableValue: selectedItem?.content,
            callSetting: { ...this.dataService.CallSetting },
            isReadOnly: this.isReadOnly,
          },
        })
        .onClose.subscribe((rs) => {
          this.filterVariable();
        });
    }
  }

  addSystemAttribute() {
    this.dialogService.open(SettingCallFlowsComponent, {
      closeOnBackdropClick: false,
      autoFocus: false,
      context: {
        updateVariable: true,
        callSetting: { ...this.dataService.CallSetting },
        isReadOnly: this.isReadOnly,
      },
    });
  }

  deleteAttribute(item: any) {
    if (item?.default !== 1) {
      this.dialogService
        .open(AlertDialogComponent, {
          autoFocus: false,
          context: {
            title: "Notification",
            question: `Do you want to delete "${item.value}" attribute?`,
            textYes: "Yes",
            textNo: "Cancel",
            statusYes: "primary",
            statusNo: "basic",
          },
        })
        .onClose.subscribe((result) => {
          if (result) {
            this.selectedItem = item;
            let index = this.dataService.ivrAttribute.indexOf(
              this.selectedItem
            );
            this.dataService.ivrAttribute.splice(index, 1);
            this.selectedItem = null;
            this.filterVariable();
          }
        });
    }
  }

  clickedRow(item) {
    this.selectedItem = item;
  }

  selectTab(tab: string) {
    if (this.tabsOpened.find((acc) => acc == tab) != null) {
      this.tabsOpened = this.tabsOpened.filter((acc) => acc != tab);
    } else {
      this.tabsOpened.push(tab);
    }
    this.expandedSections[tab] = !this.expandedSections[tab];
  }

  toggleAccordion(type: string, event: Event) {
    event.stopPropagation();

    switch (type) {
      case "system":
        this.expandedSections.system
          ? this.systemAccordion.close()
          : this.systemAccordion.open();
        break;
      case "env":
        this.expandedSections.env
          ? this.envAccordion.close()
          : this.envAccordion.open();
        break;
      case "user":
        this.expandedSections.user
          ? this.userAccordion.close()
          : this.userAccordion.open();
        break;
    }

    this.selectTab(type);
  }
}
